<template>
  <div class="big mydialog">
    <DocMsg :isFlag="doc_msg"
            :doctorId="doctorId"></DocMsg>
    <div class="page_title flex_between">
      <span>放号设置</span>
      <el-button type="primary"
                 style="width: 92px"
                 @click="back"
                 size="medium">返回</el-button>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="info">
          <div>
            <span class="item">
              <span class="black">医生姓名</span>
              <span @click="showDocMsg(detail.doctor_id)"
                    style="cursor:pointer">{{ detail.doctor_name }}</span>
            </span>
            <span class="item">
              <span class="black">性别</span>
              <span v-if="detail.sex == 1">男</span>
              <span v-if="detail.sex == 2">女</span>
            </span>
            <span class="item">
              <span class="black">手机号</span>
              <span>{{ detail.phone }}</span>
            </span>
            <span class="item">
              <span class="black">职称</span>
              <span>{{ detail.title }}</span>
            </span>
          </div>
          <div style="margin: 12px 0">
            <span class="item">
              <span class="black">所在地区</span>
              <span>{{ detail.province_name }}</span>
              <span>{{ detail.city_name }}</span>
              <span>{{ detail.district_name }}</span>
            </span>
            <span class="item">
              <span class="black">医院名称</span>
              <span>{{ detail.hospital }}</span>
            </span>
            <span class="item">
              <span class="black">科室</span>
              <span>{{ detail.department_name }}</span>
            </span>
          </div>
          <div>
            <span class="item">
              <span class="black">擅长方向</span>
              <span>{{ detail.good_at }}</span>
            </span>
          </div>
        </div>

        <div class="mode-switch">
          <div>医生预约模式设置 <el-tooltip class="item"
                        effect="light"
                        content="预约模式包含全天预约模式和时间预约模式，全天预约模式当日内的任意时间医生均可与购买预约的患者进行视频问诊。时间预约模式会为医生自动计算可接诊时间点，患者根据时间点购买预约并且在约定时间点进行就诊。同期仅支持设置1种模式。"
                        placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip></div>
          <div class="mode-btn">{{ detail.register_mode == 1 ? '全天预约模式' : `时间预约模式（每次${detail.register_time}分钟）` }}
            <el-link :underline="false"
                     @click="isRegisterMode"
                     :disabled="module_id_array[0] ? !module_id_array.includes('1536') : false"
                     type="primary">&nbsp;&nbsp;&nbsp;修 改</el-link>
          </div>
        </div>
        <div class="flex"
             style="justify-content: space-between">
          <div style="margin-right:20px">
            <div class="flex_between">
              <span>
                <span style="font-weight: 600;margin-right:20px">按周设置</span>
                <span>
                  <el-button type="text"
                             icon="el-icon-d-arrow-left"
                             @click="changeWeek('pre')"
                             v-if="is_current_week">上一周</el-button>
                  <el-button type="text"
                             @click="changeWeek('next')">下一周<i class="el-icon-d-arrow-right el-icon--right"></i></el-button>
                </span>
              </span>
              <span>
                <span>日期定位</span>
                <el-date-picker v-model="date"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                style="width:140px;margin-left:8px"
                                :picker-options="pickerOptions"
                                @change="getWeek">
                </el-date-picker>
              </span>
            </div>
            <!-- 左边 -->
            <div class="weektop">
              <div>接诊时段</div>
            </div>
            <div v-if="weekData.length">
              <div class="flex"
                   v-for="(val, i) in weekList"
                   :key="i">
                <div class="weekdays">
                  <div> {{ weeks[i] }}</div>
                  <div> {{ val[0].day }}</div>
                </div>
                <div class="daybox"
                     :class="chooseClass(val[0].day)"
                     @click="saveDoctorRegister(val[0].day,val[1],weeks[i])">
                  <div v-if="val[1]">
                    <div v-for="(item,index) in val[1]"
                         :key="index">
                      <span>{{item.start_time | dateFormat}}~{{item.end_time | dateFormat}}&nbsp;&nbsp;&nbsp;</span>
                      <template v-if="detail.register_mode == 1">
                        <div>
                          <span>
                            放号：<span>{{item.num}}</span>
                          </span>
                          <span v-if="item.num_plus"
                                style="margin-left:5px">
                            加号：<span>{{item.num_plus}}</span>
                          </span>
                        </div>
                      </template>
                      <template v-if="detail.register_mode == 2">
                        <span>每次{{ item.register_time }}分钟,号数{{ item.num }}</span>
                      </template>
                      <div class="stop"
                           v-if="item.status==0 ">已停用</div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <!-- 右边 -->
          <div style="flex:1;padding:10px 20px 0 0">
            <div class="flex_between">
              <span>
                <span style="font-weight: 600;margin-right:20px">已设置记录</span>
                <span>近半年内，已设置{{day_num}}天</span>
              </span>
              <span style="color:#FD7110">系统只支持最近半年的设置</span>
            </div>
            <div style="border: solid 1px #c9cbd6;margin-top:27px;">
              <el-table ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%;"
                        :header-cell-style="{ background: '#F5F5F5' }">
                <el-table-column prop="date_time"
                                 label="预约问诊日期">
                  <template slot-scope="scope">
                    <div>{{ scope.row.date_time }}</div>
                    <span>{{scope.row.start_time | dateFormat}}~{{scope.row.end_time | dateFormat}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="week"
                                 label="周号">
                  <template slot-scope="scope">
                    {{ scope.row.week | weekNum }}
                  </template>
                </el-table-column>
                <el-table-column label="当前状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.open_status == 1">已放号</span>
                    <span v-if="scope.row.open_status == 0">待放号</span>
                  </template>
                </el-table-column>
                <el-table-column label="放号数">
                  <template slot-scope="scope">
                    <div>{{scope.row.num}}</div>
                    <span v-if="scope.row.num_plus">加号：{{scope.row.num_plus}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="开始放号时间"
                                 prop="open_time">
                </el-table-column>
                <el-table-column label="截止放号时间"
                                 prop="close_time">
                </el-table-column>
                <el-table-column label="预约问诊费用">
                  <template slot-scope="scope">
                    <div>{{scope.row.price}}</div>
                    <span v-if="scope.row.num_plus">加号：{{scope.row.price_plus}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button v-if="detail.register_mode == 1"
                               type="text"
                               @click="saveDoctorRegister(scope.row.date_time,scope.row,scope.row.week)"
                               :disabled="module_id_array[0] ? !module_id_array.includes('814') : false">修改</el-button>
                    <el-button v-if="detail.register_mode == 2"
                               type="text"
                               @click="getRegisterData(scope.row.doctor_id,scope.row.date_time,scope.row.week)"
                               :disabled="module_id_array[0] ? !module_id_array.includes('814') : false">修改</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="text-align:center">
              <el-pagination @size-change="handleSizeChange"
                             @current-change="handleCurrentChange"
                             :current-page="currentPage"
                             :page-sizes="[10, 20, 50, 100]"
                             :page-size="10"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="totalNum"
                             style="margin:20px 0"></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 设置问诊弹窗 -->
    <el-dialog :title="title"
               :visible.sync="register"
               width="600px"
               :close-on-click-modal="false">
      <div class="registerdialogbox">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="120px"
                 class="demo-ruleForm">

          <template v-if="detail.register_mode == 1">
            <el-form-item label="出诊开始时间"
                          prop="start_time">
              <el-time-picker v-model="ruleForm.start_time"
                              value-format="HH:mm"
                              format="HH : mm"
                              style="width:180px">
              </el-time-picker>
            </el-form-item>
            <el-form-item label="出诊结束时间"
                          prop="end_time">
              <el-time-picker v-model="ruleForm.end_time"
                              value-format="HH:mm"
                              format="HH : mm"
                              style="width:180px">
              </el-time-picker>
            </el-form-item>
            <el-form-item label="放号数"
                          prop="num">
              <el-input-number v-model="ruleForm.num"
                               :min="1"
                               :precision="0"
                               :controls="false"
                               style="width:180px"></el-input-number>
              <div style="color:#FF8C28;margin-top:-8px">请保证，每号平均10分钟以上时间</div>
            </el-form-item>
          </template>

          <template v-if="detail.register_mode == 2">
            <el-form-item label="出诊设置"
                          prop="time_obj"
                          class="time-obj"
                          :style="{height:`${ruleForm.time_obj.length *166}px`}">
              <el-button type="primary"
                         size="small"
                         @click="addTimeBtn"
                         :disabled="module_id_array[0] ? !module_id_array.includes('814') : false">添加出诊时段</el-button>

              <div v-for="(item,index) in ruleForm.time_obj"
                   :key="index"
                   class="time-obj-item">
                <div>{{`出诊时段${index+1}`}}
                  <el-button v-show="ruleForm.time_obj.length>1"
                             size="mini"
                             @click="delTimeBtn(index)"
                             style="margin-left:10px">删除</el-button>
                </div>
                <div class="time-obj-time">
                  <span>出诊开始时间&nbsp;&nbsp;&nbsp;</span>
                  <el-time-picker v-model="item.start_time"
                                  value-format="HH:mm"
                                  format="HH : mm"
                                  style="width:180px"
                                  :picker-options="{selectableRange: index ? `${ruleForm.time_obj[index-1].end_time}:00 - 23:59:00` :'00:00:00 - 23:59:00'}"> </el-time-picker>
                </div>
                <div class="time-obj-time">
                  <span>出诊结束时间&nbsp;&nbsp;&nbsp;</span>
                  <el-time-picker v-model="item.end_time"
                                  value-format="HH:mm"
                                  format="HH : mm"
                                  style="width:180px"> </el-time-picker>
                </div>
              </div>

            </el-form-item>
          </template>

          <el-form-item label="开始放号时间"
                        style="margin-top:30px"
                        required="">
            <div class="flex">
              <span style="margin-right:5px">预约问诊日期</span>
              <el-form-item prop="open_day">
                <el-select v-model="ruleForm.open_day"
                           style="width:110px;"
                           placeholder="">
                  <el-option v-for="item in 30"
                             :key="item"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <span style="margin:0 20px 0 5px">天之前</span>
              <el-form-item prop="open_day_time">
                <el-time-picker v-model="ruleForm.open_day_time"
                                value-format="HH:mm"
                                format="HH : mm"
                                style="width:120px;margin-right:5px">
                </el-time-picker>
              </el-form-item>
              <span>开始</span>
            </div>
          </el-form-item>
          <el-form-item label="截止放号时间"
                        required>
            <div class="flex">
              <span style="margin-right:5px">预约问诊日期</span>
              <el-form-item prop="close_day">
                <el-select v-model="ruleForm.close_day"
                           style="width:110px;"
                           placeholder="">
                  <el-option v-for="item in 31"
                             :key="item"
                             :label="item-1"
                             :value="item-1">
                  </el-option>
                </el-select>
              </el-form-item>
              <span style="margin:0 20px 0 5px">天之前</span>
              <el-form-item prop="close_day_time">
                <el-time-picker v-model="ruleForm.close_day_time"
                                value-format="HH:mm"
                                format="HH : mm"
                                style="width:120px;margin-right:5px">
                </el-time-picker>
              </el-form-item>
              <span>结束</span>
            </div>
          </el-form-item>
          <el-form-item label="预约问诊费用"
                        prop="price">
            <el-input-number v-model="ruleForm.price"
                             :min="0"
                             :max="9999"
                             :controls="false"></el-input-number>
          </el-form-item>

          <template v-if="detail.register_mode == 1">
            <el-form-item label="时间显示"
                          prop="time_show">
              <el-radio-group v-model="ruleForm.time_show">
                <el-radio :label="1">显示</el-radio>
                <el-radio :label="0">不显示</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>

          <el-form-item prop="set_status">
            <el-checkbox v-model="ruleForm.set_status"
                         :true-label="1"
                         :false-label="0">以后每{{dialog_week}}，都这样设置</el-checkbox>
          </el-form-item>
        </el-form>
        <div style="text-align: center">
          <el-button plain
                     size="medium"
                     @click="register=false">取消</el-button>
          <el-button type="primary"
                     size="medium"
                     @click="submit('ruleForm')"
                     :disabled="module_id_array[0] ? !module_id_array.includes('814') : false">确认</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 追加医生的放号数量/修改预约费用 -->
    <el-dialog :title="title"
               :visible.sync="registerAdd"
               width="360px"
               :close-on-click-modal="false"
               :before-close="closeRegisterAdd">

      <template v-if="detail.register_mode == 1">
        <div class="registerdialogbox">
          <div class="diaitem flex_between">
            <span class="diatitle">出诊</span>
            <el-button type="primary"
                       size="mini"
                       @click="disableRegister(0)"
                       v-if="dayData.status==1"
                       :disabled="module_id_array[0] ? !module_id_array.includes('821') : false">紧急停用</el-button>
          </div>

          <div class="diaitem">
            <span class="diatitle">出诊开始时间</span>
            <span>{{dayData.start_time | dateFormat}}</span>
          </div>
          <div class="diaitem">
            <span class="diatitle">出诊结束时间</span>
            <span>{{dayData.end_time | dateFormat}}</span>
          </div>
          <div class="diaitem">
            <span class="diatitle">放号数</span>
            <span>{{dayData.num}}</span>
          </div>
          <div class="diaitem">
            <span class="diatitle">开始放号时间</span>
            <span>{{dayData.open_time }}</span>
          </div>
          <div class="diaitem">
            <span class="diatitle">截止放号时间</span>
            <span>{{dayData.close_time}}</span>
          </div>
          <div class="diaitem"
               v-if="is_over ">
            <span class="diatitle">预约问诊费用</span>
            <span>{{dayData.price}}</span>
          </div>
          <div style="color:#FD7110;text-align:center"
               class="diaitem"
               v-if="is_over">当前已截止放号，不可修改</div>
          <div class="diaitem"
               v-if="!is_over">
            <span class="diatitle">预约问诊费用</span>
            <el-input-number v-model="dayData.price"
                             :min="0"
                             :max="9999"
                             :controls="false"
                             :disabled="dayData.status==0"></el-input-number>
          </div>
          <div class="diaitem"
               v-if="!is_over">
            <span class="diatitle">追加放号数</span>
            <el-input-number v-model="dayData.num_plus"
                             :min="1"
                             :precision="0"
                             :controls="false"
                             style="width:180px"
                             :disabled="dayData.status==0"></el-input-number>
          </div>

          <div class="diaitem"
               v-if="!is_over">
            <span class="diatitle">时间显示</span>
            <el-radio-group v-model="dayData.time_show"
                            :disabled="dayData.status==0">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </div>

          <div style="text-align: center"
               v-if="!is_over&&dayData.status==1">
            <el-button plain
                       size="medium"
                       @click="closeRegisterAdd">取消</el-button>
            <el-button type="primary"
                       size="medium"
                       @click="addRegisterNum"
                       :disabled="module_id_array[0] ? !module_id_array.includes('816') : false">确认</el-button>
          </div>
          <div v-if="dayData.status==0"
               style="text-align: center">
            <el-button type="primary"
                       size="medium"
                       @click="disableRegister(1)"
                       :disabled="module_id_array[0] ? !module_id_array.includes('821') : false">启用</el-button>
          </div>
        </div>
      </template>
      <template v-if="detail.register_mode == 2">
        <div class="registerdialogbox">
          <div class="diaitem flex_between">
            <span class="diatitle">出诊设置</span>
            <el-button type="primary"
                       size="mini"
                       @click="disableRegister(0)"
                       v-if="dayData.length&&dayData[0].status==1"
                       :disabled="module_id_array[0] ? !module_id_array.includes('821') : false">紧急停用</el-button>
          </div>

          <div class="diaitem"
               v-for="(item,index) in dayData"
               :key="index">
            <div class="diatitle">出诊时段{{index+1}}</div>
            <div class="diaitem-2">
              <span class="diatitle">出诊开始时间</span>
              <span>{{item.start_time | dateFormat}}</span>
            </div>
            <div class="diaitem-2">
              <span class="diatitle">出诊结束时间</span>
              <span>{{item.end_time | dateFormat}}</span>
            </div>
          </div>
          <div class="diaitem">
            <span class="diatitle">开始放号时间</span>
            <span v-if="dayData.length">{{dayData[0].open_time }}</span>
          </div>
          <div class="diaitem">
            <span class="diatitle">截止放号时间</span>
            <span v-if="dayData.length">{{dayData[0].close_time}}</span>
          </div>

          <div style="color:#FD7110;text-align:center"
               class="diaitem"
               v-if="is_over">当前已截止放号，不可修改</div>
          <div style="text-align: center"
               v-if="!is_over&&dayData.length&&dayData[0].status==1">
            <el-button plain
                       size="medium"
                       @click="closeRegisterAdd">取消</el-button>
          </div>
          <div v-if="dayData.length&&dayData[0].status==0"
               style="text-align: center">
            <el-button type="primary"
                       size="medium"
                       @click="disableRegister(1)"
                       :disabled="module_id_array[0] ? !module_id_array.includes('821') : false">启用</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <!-- 模式切换弹框 -->
    <el-dialog title="提示"
               :visible.sync="modeDia"
               width="460px"
               custom-class="mode-dia">
      <div style="padding:10px">
        <el-form :model="modeForm"
                 label-width="100px">
          <el-form-item label="医生预约模式"
                        style="display:flex;">
            <el-radio-group v-model="modeForm.register_mode">
              <el-radio :label="1">全天预约模式</el-radio>
              <el-radio :label="2">时间预约模式</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="modeForm.register_mode === 2"
                        label="接诊时长"
                        style="display:flex;">
            <span>每次&nbsp;</span>
            <el-select v-model="modeForm.register_time"
                       size="small"
                       placeholder="请选择">
              <el-option label="3"
                         :value="3"></el-option>
              <el-option label="10"
                         :value="10"></el-option>
              <el-option label="15"
                         :value="15"></el-option>
              <el-option label="30"
                         :value="30"></el-option>
            </el-select>
            <span>&nbsp;分钟</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small"
                   @click="modeDia = false">取 消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="confirmModeBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import activity from '@/api/activity.js';
import dayjs from 'dayjs';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  inject: ['reload'],
  data() {
    let checkStartTime = (rule, value, callback) => {
      if (value) {
        if (this.ruleForm.end_time && this.ruleForm.start_time) {
          if (this.ruleForm.end_time < this.ruleForm.start_time) {
            return callback(new Error('出诊结束时间必须大于开始时间'));
          } else {
            return callback();
          }
        }
      } else {
        return callback();
      }
    };
    let checkOpenDay = (rule, value, callback) => {
      if (value) {
        if (this.ruleForm.open_day && this.ruleForm.close_day) {
          if (this.ruleForm.open_day < this.ruleForm.close_day) {
            return callback(new Error('放号截止时间必须大于开始时间'));
          } else {
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        return callback();
      }
    };
    let checkOpenTime = (rule, value, callback) => {
      if (value) {
        if (
          this.ruleForm.open_day &&
          this.ruleForm.close_day &&
          this.ruleForm.open_day_time &&
          this.ruleForm.close_day_time
        ) {
          if (this.ruleForm.open_day == this.ruleForm.close_day) {
            if (this.ruleForm.close_day_time < this.ruleForm.open_day_time) {
              return callback(new Error('放号截止时间必须大于开始时间'));
            } else {
              return callback();
            }
          } else if (this.ruleForm.open_day > this.ruleForm.close_day) {
            return callback();
          } else {
            return callback(new Error('放号截止时间必须大于开始时间'));
          }
        } else {
          return callback();
        }
      } else {
        return callback();
      }
    };
    let checkTimeObj = (rule, value, callback) => {
      let bol = value.some((item) => {
        return item.start_time == '' || item.end_time == '';
      });
      let bol2 = value.some((item) => {
        return item.end_time <= item.start_time;
      });
      if (bol) {
        return callback(new Error('请填写完整'));
      } else if (bol2) {
        return callback(new Error('出诊结束时间必须大于开始时间'));
      } else {
        return callback();
      }
    };
    return {
      pickerOptions: {
        firstDayOfWeek: 1
      },
      doctor_id: this.$route.query.doctor_id,
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      day_num: 0,
      tableData: [],
      date: '',
      weekList: [],
      weekData: [],
      weeks: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      days: [],
      detail: {},
      register: false,
      title: '11月2日周二上午',
      dialog_week: '周二',
      // is_out: 1,
      ruleForm: {
        doctor_id: this.$route.query.doctor_id,
        date_time: '2021-11-12', //出诊日期（2021-11-12）
        start_time: '', //出诊开始时间（2021-11-12  08:30）
        end_time: '', //出诊结束时间（2021-11-12  12:00）
        num: '', //需要放的号数
        open_day: '', //出诊前多少天开始放号
        open_day_time: '', //开始放号几天前的时间点  如08:30
        close_day: '', //出诊前多少天结束放号
        close_day_time: '', //结束放号几天前的时间点  如18:30
        price: undefined, //预约费用
        set_status: 1, //以后每周都这样设置 0不是  1是的
        time_show: 0,
        time_obj: [{ start_time: '', end_time: '' }]
      },
      rules: {
        start_time: [
          {
            required: true,
            message: '请选择出诊开始时间',
            trigger: 'blur'
          },
          { validator: checkStartTime, trigger: ['blur', 'change'] }
        ],
        end_time: [
          {
            required: true,
            message: '请选择出诊结束时间',
            trigger: 'blur'
          },
          { validator: checkStartTime, trigger: ['blur', 'change'] }
        ],
        num: [{ required: true, message: '请输入放号数', trigger: 'blur' }],
        open_day: [
          { required: true, message: '请填写开始放号时间', trigger: 'blur' },
          { validator: checkOpenDay, trigger: ['blur', 'change'] }
        ],
        open_day_time: [
          { required: true, message: '请填写开始放号时间', trigger: 'blur' },
          { validator: checkOpenTime, trigger: ['blur', 'change'] }
        ],
        close_day: [
          { required: true, message: '请填写结束放号时间', trigger: 'blur' },
          { validator: checkOpenDay, trigger: ['blur', 'change'] }
        ],
        close_day_time: [
          { required: true, message: '请填写开始放号时间', trigger: 'blur' },
          { validator: checkOpenTime, trigger: ['blur', 'change'] }
        ],
        price: [{ required: true, message: '请填写预约费用', trigger: 'blur' }],
        time_obj: [
          {
            required: true,
            validator: checkTimeObj,
            trigger: ['change']
          }
        ]
      },
      registerAdd: false,
      num_plus: undefined,
      price_plus: undefined,
      reg_setting_id: 0,
      dayData: [],
      is_over: false,
      doc_msg: false,
      doctorId: '',
      modeDia: false,
      modeForm: {
        doctor_id: this.$route.query.doctor_id,
        register_mode: 1,
        register_time: 10
      },
      mode2Edit: false
    };
  },
  components: {
    DocMsg
  },
  filters: {
    dateFormat(val) {
      return dayjs.unix(val).format('HH:mm');
    },
    weekNum(val) {
      switch (val) {
        case 1:
          return '周一';
        case 2:
          return '周二';
        case 3:
          return '周三';
        case 4:
          return '周四';
        case 5:
          return '周五';
        case 6:
          return '周六';
        case 7:
          return '周日';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    is_current_week() {
      let now = new Date();
      var week = now.getDay(); //获取时间的星期数
      var minus = week ? week - 1 : 6;
      now.setDate(now.getDate() - minus); //获取minus天前的日期
      let now_time = new Date(now).getTime();
      let next_time = new Date(this.weekList[0][0].day).getTime();
      if (next_time > now_time) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.getDoctor();
    let now = dayjs(new Date()).format('YYYY-MM-DD');
    this.getWeek(now);
    this.getTableList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取医生详情
    getDoctor() {
      let doctor_id = this.doctor_id;
      this.axios
        .post('platform/doctor/doctorItem', { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            console.log(res.data.info);
            this.detail = res.data.info;
            let good_at = [];
            good_at = this.detail.be_good_at.map((item) => {
              return item.be_good_at_name;
            });
            this.detail.good_at = good_at.toString();
            this.value = this.detail.is_scheduling ? true : false;
            this.modeForm.register_mode = res.data.info.register_mode;
            this.modeForm.register_time = res.data.info.register_time;
          }
        });
    },
    //医生预约问诊半年设置列表
    getTableList() {
      let data = {
        doctor_id: this.doctor_id,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios
        .post('platform/doctor/doctorRegisterList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.date_time = dayjs.unix(item.date_time).format('YYYY-MM-DD');
              item.open_time = dayjs
                .unix(item.open_time)
                .format('YYYY-MM-DD HH:mm');
              item.close_time = dayjs
                .unix(item.close_time)
                .format('YYYY-MM-DD HH:mm');
              // item.start_time = dayjs.unix(item.start_time).format('HH:mm');
              // item.end_time = dayjs.unix(item.end_time).format('HH:mm');
              // item.week = this.weekNum(item.week);
              return item;
            });
            this.totalNum = res.data.total;
            this.day_num = res.data.day_num;
          }
        });
    },

    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getTableList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableList();
    },
    // 添加时间段
    addTimeBtn() {
      let len = this.ruleForm.time_obj.length;
      if (len >= 3) {
        this.$message.warning('多可添加三个时段');
        return;
      }
      let obj = {
        start_time: '',
        end_time: ''
      };
      this.ruleForm.time_obj.push(obj);
    },
    delTimeBtn(index) {
      this.ruleForm.time_obj.splice(index, 1);
    },
    //医生预约问诊按周设置列表
    getList(date) {
      let loading = this.$loading();
      let data = {
        doctor_id: this.doctor_id,
        date: date
      };
      this.axios
        .post('platform/doctor/weekDoctorRegister', data)
        .then((res) => {
          if (res.code == 0) {
            let { list } = res.data;
            console.log(list);
            if (!Object.keys(list).length) {
              this.weekData = this.weekList;
              loading.close();
              return false;
            }
            for (let key in list) {
              list[key][0].date_time = dayjs
                .unix(list[key][0].date_time)
                .format('YYYY-MM-DD');
              // list[key][0].start_time = dayjs
              //   .unix(list[key][0].start_time)
              //   .format('HH:mm');
              // list[key][0].end_time = dayjs
              //   .unix(list[key][0].end_time)
              //   .format('HH:mm');
              list[key][0].open_time = dayjs
                .unix(list[key][0].open_time)
                .format('YYYY-MM-DD HH:mm');
              list[key][0].close_time = dayjs
                .unix(list[key][0].close_time)
                .format('YYYY-MM-DD HH:mm');
            }
            for (let i = 0; i < this.weekList.length; i++) {
              for (let key in list) {
                if (this.weekList[i][0].day == key) {
                  this.weekList[i][1] = list[key];
                }
              }
            }
            console.log(this.weekList, 'weeklist');
            this.weekData = this.weekList;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    //切换周
    changeWeek(a) {
      this.weekData = [];
      let now_monday = new Date(this.weekList[0][0].day).getTime();
      let current_day = new Date().getTime();
      //上一周
      if (a == 'pre') {
        let next_monday = dayjs(now_monday - 7 * 24 * 60 * 60 * 1000).format(
          'YYYY-MM-DD'
        );
        this.getWeek(next_monday);
      }
      //下一周 只能设置近26周的记录
      if (a == 'next') {
        let next_monday = dayjs(now_monday + 7 * 24 * 60 * 60 * 1000).format(
          'YYYY-MM-DD'
        );
        if (
          (new Date(next_monday).getTime() - current_day) /
            (7 * 24 * 60 * 60 * 1000) >
          25
        ) {
          this.$message.error('只能设置近26周的记录');
          this.weekData = this.weekList;
          return false;
        }
        this.getWeek(next_monday);
      }
    },
    //设置按钮
    saveDoctorRegister(day, val, week) {
      console.log(val);
      switch (week) {
        case 1:
          week = '周一';
          break;
        case 2:
          week = '周二';
          break;
        case 3:
          week = '周三';
          break;
        case 4:
          week = '周四';
          break;
        case 5:
          week = '周五';
          break;
        case 6:
          week = '周六';
          break;
        case 7:
          week = '周日';
          break;
        default:
          week = week;
          break;
      }
      this.mode2Edit = false;
      if (!Array.isArray(val) && val) {
        val = [val];
      }
      let oldVal = null;
      if (val) {
        oldVal = JSON.parse(JSON.stringify(val));
      }
      console.log(val);
      this.dialog_week = week;
      this.title = day + week;
      let now_day = dayjs(new Date()).format('YYYY-MM-DD');
      let now_time = dayjs(new Date()).format('YYYY-MM-DD HH:mm');
      if (day <= now_day) return false;
      if (!val) {
        switch (this.detail.register_mode) {
          case 1:
            this.ruleForm = {
              doctor_id: this.doctor_id,
              date_time: day,
              start_time: '',
              end_time: '',
              num: '',
              open_day: '',
              open_day_time: '',
              close_day: '',
              close_day_time: '',
              price: undefined,
              set_status: 1,
              time_show: 0
            };
            break;
          case 2:
            this.ruleForm = {
              doctor_id: this.doctor_id,
              date_time: day,
              num: '',
              open_day: '',
              open_day_time: '',
              close_day: '',
              close_day_time: '',
              price: undefined,
              set_status: 1,
              time_obj: [{ start_time: '', end_time: '' }]
            };
            break;
        }
        this.register = true;
        return false;
      }
      //开始放号时间之前修改
      val = val[0];

      if (now_time < val.open_time) {
        console.log(val);
        if (val) {
          switch (this.detail.register_mode) {
            case 1:
              this.ruleForm = {
                doctor_id: this.doctor_id,
                reg_setting_id: val.reg_setting_id,
                date_time: day,
                start_time: dayjs.unix(val.start_time).format('HH:mm'),
                end_time: dayjs.unix(val.end_time).format('HH:mm'),
                num: val.num,
                open_day: val.open_day,
                open_day_time: val.open_day_time,
                close_day: val.close_day,
                close_day_time: val.close_day_time,
                price: val.price,
                set_status: val.set_status,
                time_show: val.time_show
              };
              break;
            case 2:
              this.ruleForm = {
                doctor_id: this.doctor_id,
                date_time: day,
                open_day: val.open_day,
                open_day_time: val.open_day_time,
                close_day: val.close_day,
                close_day_time: val.close_day_time,
                price: val.price,
                set_status: val.set_status,
                time_obj: oldVal.map((item) => {
                  item.start_time = dayjs.unix(item.start_time).format('HH:mm');
                  item.end_time = dayjs.unix(item.end_time).format('HH:mm');
                  return item;
                })
              };
              this.mode2Edit = true;
              break;
          }
        }
        this.register = true;
        //开始放号时间之后  截止时间之前
      } else if (val.open_time < now_time && now_time < val.close_time) {
        this.dayData = this.detail.register_mode == 1 ? val : oldVal;
        console.log(this.dayData);
        this.registerAdd = true;
        this.is_over = false;
        //截止时间之后
      } else if (now_time > val.close_time || now_time == val.close_time) {
        this.dayData = this.detail.register_mode == 1 ? val : oldVal;
        this.registerAdd = true;
        this.is_over = true;
      }
    },
    // 获取预约设置信息
    getRegisterData(doctor_id, date_time, week) {
      let params = {
        doctor_id,
        date_time: dayjs(date_time).valueOf() / 1000
      };
      return activity.getRegisterData(params).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          let list = data.map((item) => {
            item.date_time = dayjs.unix(item.date_time).format('YYYY-MM-DD');
            item.open_time = dayjs
              .unix(item.open_time)
              .format('YYYY-MM-DD HH:mm');
            item.close_time = dayjs
              .unix(item.close_time)
              .format('YYYY-MM-DD HH:mm');
            return item;
          });
          this.saveDoctorRegister(list[0].date_time, list, week);
        }
      });
    },
    //添加/编辑
    submit(formName) {
      // if (this.is_out == 0 && this.ruleForm.reg_setting_id) {
      //   let data = {
      //     reg_setting_id: this.ruleForm.reg_setting_id,
      //     doctor_id: this.doctor_id,
      //     set_status: this.ruleForm.set_status
      //   };
      //   if (this.ruleForm.set_status == 1) {
      //     this.$confirm(
      //       `你确认将以后每${this.dialog_week}的出诊都调整为，这样的设置？（以前${this.dialog_week}的设置不调整）`,
      //       '提示',
      //       {
      //         confirmButtonText: '确定',
      //         cancelButtonText: '取消'
      //       }
      //     )
      //       .then(() => {
      //         let loading = this.$loading();
      //         this.axios
      //           .post('platform/doctor/deldoctorRegister', data)
      //           .then((res) => {
      //             if (res.code == 0) {
      //               this.$message.success('已取消出诊');
      //               this.register = false;
      //               if (this.date) {
      //                 this.getWeek(this.date);
      //               } else {
      //                 let now = dayjs(new Date()).format('YYYY-MM-DD');
      //                 this.getWeek(now);
      //               }
      //               this.getTableList();
      //             }
      //             loading.close();
      //           })
      //           .catch(() => {
      //             loading.close();
      //           });
      //       })
      //       .catch(() => {});
      //   } else {
      //     this.$confirm('确认取消当天的问诊？', '提示', {
      //       confirmButtonText: '确定',
      //       cancelButtonText: '取消'
      //     })
      //       .then(() => {
      //         let loading = this.$loading();
      //         this.axios
      //           .post('platform/doctor/deldoctorRegister', data)
      //           .then((res) => {
      //             if (res.code == 0) {
      //               this.$message.success('已取消出诊');
      //               this.register = false;
      //               if (this.date) {
      //                 this.getWeek(this.date);
      //               } else {
      //                 let now = dayjs(new Date()).format('YYYY-MM-DD');
      //                 this.getWeek(now);
      //               }
      //               this.getTableList();
      //             }
      //             loading.close();
      //           })
      //           .catch(() => {
      //             loading.close();
      //           });
      //       })
      //       .catch(() => {});
      //   }
      //   return false;
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm;
          console.log(data);
          let confirmTitle =
            this.ruleForm.set_status == 1
              ? `你确认将以后每${this.dialog_week}的出诊都调整为，这样的设置？（以前${this.dialog_week}的设置不调整）`
              : `你确认将${this.title}的出诊调整为这样的设置？`;
          this.$confirm(confirmTitle, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          })
            .then(() => {
              switch (this.detail.register_mode) {
                case 1:
                  this.saveDoctorRegisterInterface(data);
                  break;
                case 2:
                  if (this.mode2Edit) {
                    this.updateTimeDoctorRegister(data);
                  } else {
                    this.addTimeDoctorRegister(data);
                  }
                  break;
              }
            })
            .catch(() => {});
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    saveDoctorRegisterInterface(params) {
      let loading = this.$loading();
      activity
        .saveDoctorRegister(params)
        .then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success('添加预约问诊成功');
            this.register = false;
            if (this.date) {
              this.getWeek(this.date);
            } else {
              let now = dayjs(new Date()).format('YYYY-MM-DD');
              this.getWeek(now);
            }
            // this.getTableList();
            this.reload();
          }
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    addTimeDoctorRegister(params) {
      let loading = this.$loading();
      activity
        .addTimeDoctorRegister(params)
        .then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success('添加预约问诊成功');
            this.register = false;
            if (this.date) {
              this.getWeek(this.date);
            } else {
              let now = dayjs(new Date()).format('YYYY-MM-DD');
              this.getWeek(now);
            }
            // this.getTableList();
            this.reload();
          }
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    updateTimeDoctorRegister(params) {
      let loading = this.$loading();
      activity
        .updateTimeDoctorRegister(params)
        .then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success('修改预约问诊成功');
            this.register = false;
            if (this.date) {
              this.getWeek(this.date);
            } else {
              let now = dayjs(new Date()).format('YYYY-MM-DD');
              this.getWeek(now);
            }
            // this.getTableList();
            this.reload();
          }
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    //追加医生的放号数量  价格
    addRegisterNum() {
      if (
        !this.dayData.num_plus ||
        (!this.dayData.price_plus && this.dayData.price_plus != 0)
      ) {
        this.$message.error('请填写加号数量和加号费用');
        return false;
      }
      let data = {
        reg_setting_id: this.dayData.reg_setting_id,
        doctor_id: this.doctor_id,
        num_plus: this.dayData.num_plus,
        price_plus: this.dayData.price_plus,
        time_show: this.dayData.time_show
      };
      console.log(data);
      this.axios
        .post('platform/doctor/addDoctorRegisterNum', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('添加成功');
            this.registerAdd = false;
            if (this.date) {
              this.getWeek(this.date);
            } else {
              let now = dayjs(new Date()).format('YYYY-MM-DD');
              this.getWeek(now);
            }
            this.getTableList();
          }
        });
    },
    //关闭加号弹窗
    closeRegisterAdd() {
      this.registerAdd = false;
      if (this.date) {
        this.getWeek(this.date);
      } else {
        let now = dayjs(new Date()).format('YYYY-MM-DD');
        this.getWeek(now);
      }
      this.getTableList();
    },
    //紧急停用 启用
    disableRegister(status) {
      let data = {
        reg_setting_id:
          this.detail.register_mode == 1
            ? this.dayData.reg_setting_id
            : this.dayData[0].reg_setting_id,
        status: status
      };
      let msg =
        '是否遇到紧急情况，需要停用已放号的预约计划？请谨慎操作，并做好后续患者退费及解释工作。';
      if (status == 1) {
        msg = '是否重新启用预约问诊计划？';
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let loading = this.$loading();
          this.axios
            .post('platform/doctor/disableDoctorRegister', data)
            .then((res) => {
              if (res.code == 0) {
                if (status == 1) {
                  this.$message.success('已重新启用预约问诊计划');
                } else {
                  this.$message.success('已紧急停用预约问诊计划');
                }
                this.registerAdd = false;
                if (this.date) {
                  this.getWeek(this.date);
                } else {
                  let now = dayjs(new Date()).format('YYYY-MM-DD');
                  this.getWeek(now);
                }
                this.getTableList();
              }
              loading.close();
            })
            .catch(() => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    back() {
      history.back();
    },
    //今天之前加class名'other'
    chooseClass(day) {
      let now = dayjs(new Date()).format('YYYY-MM-DD');
      if (day <= now) return 'other';
    },
    getWeek(target) {
      if (!target) {
        return false;
      }
      this.weekData = [];
      let now_monday = new Date(target).getTime();
      let current_day = new Date().getTime();
      if (
        (new Date(now_monday).getTime() - current_day) /
          (7 * 24 * 60 * 60 * 1000) >
        25
      ) {
        this.$message.error('只能设置近26周的记录');
        this.weekData = this.weekList;
        this.date = '';
        return false;
      }
      let now = new Date(target);
      let now_day = now.getDay();
      if (now_day == 0) {
        now_day = 7;
      }
      let now_time = now.getTime();
      let result = [1, 2, 3, 4, 5, 6, 7];
      this.weekList = result.map((i) => {
        let day = dayjs(
          new Date(now_time + 24 * 60 * 60 * 1000 * (i - now_day)).getTime()
        ).format('YYYY-MM-DD');
        let data = [{ day }];
        return data;
      });
      this.getList(target);
    },
    // 能否修改预约模式
    isRegisterMode() {
      activity.isRegisterMode({ doctor_id: this.doctor_id }).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          if (data.status === 1) {
            this.modeDia = true;
            this.modeForm.register_mode = this.detail.register_mode;
            this.modeForm.register_time = this.detail.register_time;
          } else {
            this.$message.warning(
              '您当前预约模式下还有未结束的预约咨询，需将当前模式下的所有预约患者结束咨询方可修改。'
            );
          }
        }
      });
    },
    confirmModeBtn() {
      this.$confirm(
        '切换预约模式后，将清空今天以后的预约设置，确定要切换预约模式吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      )
        .then(() => {
          let params = Object.assign({}, this.modeForm);
          activity.setRegisterMode(params).then((res) => {
            let { code, data } = res;
            if (code === 0) {
              this.$message.success('切换成功');
              // this.modeDia = false;
              // this.dayData = [];
              this.reload();
              this.getDoctor();
            }
          });
        })
        .catch(() => {
          this.modeDia = false;
        });
    }
  }
};
</script>
<style lang="scss">
.mode-dia {
  .el-form-item__content {
    margin: 0 !important;
  }
}
</style>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.info {
  background: #f5f5f5;
  padding: 10px;
  margin-bottom: 20px;
  .item {
    margin-right: 50px;
  }
}
.mode-switch {
  width: 500px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  .mode-btn {
    display: flex;
    align-items: center;
  }
}

.black {
  font-weight: 700;
  margin-right: 20px;
}
.weektop {
  width: 400px;
  background-color: hsla(144, 51%, 10%, 0.4);
  padding-left: 130px;
  font-size: 18px;
  font-weight: 700;
  margin-top: 16px;
  text-align: center;
  line-height: 50px;
  & > div {
    padding-right: 50px;
  }
}
.title {
  font-size: 20px;
  letter-spacing: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #9ea9a2;
  color: #ffffff;
  height: 50px;
}
.weekdays {
  width: 130px;
  background: #ffffff;
  background-color: #9ea9a2;
  font-weight: 600;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.daybox {
  width: 100%;
  box-sizing: border-box;
  font-weight: 600;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #9ea9a2;
  border-bottom: 1px solid #9ea9a2;
  cursor: pointer;
  text-align: center;
  position: relative;
  .stop {
    position: absolute;
    right: 5px;
    bottom: 3px;
    color: red;
  }
}
.other {
  background: #cccc;
  cursor: default;
}
.days {
  padding: 0;
  background: #ffffff;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  border-right: 1px solid #333;
  border-top: 1px solid #333;
}
.days li {
  display: inline-block;
  width: 14.285714%;
  text-align: center;
  padding-bottom: 8px;
  padding-top: 15px;
  height: 89px;
  box-sizing: border-box;
  border-left: 1px solid #333;
  border-bottom: 1px solid #333;
}

.days li:hover {
  background: #e1e1e1;
}
.registerdialogbox {
  padding: 20px 15px;
  text-align: left;
}
.diaitem {
  margin-bottom: 15px;
  .diatitle {
    display: inline-block;
    width: 100px;
    text-align: right;
    font-weight: 700;
    margin-right: 10px;
  }
  .diaitem-2 {
    padding: 10px 0 0 50px;
  }
}
</style>
<style lang="scss">
.time-obj {
  .el-form-item__content {
    height: 100%;
    padding-bottom: 10px;
  }
  .time-obj-item {
    .time-obj-time {
      margin: 10px 0;
      padding-left: 20px;
    }
  }
}
.registerdialogbox .el-form-item {
  margin-bottom: 15px;
}
.registerdialogbox .el-form-item__error {
  padding-top: 0px;
  width: 170px;
}
</style>